module.exports = __webpack_public_path__ + "static/media/Thai-Public.215a1637.svg";